import React, { useLayoutEffect } from "react";
import fieldDefinitionKeys from "../../../frontend/definitions/fieldDefinitionKeys";
import { ProfileButton } from "../../../frontend/components/LearnerHome/ProfileButton";
import { Toolkit } from "../../../frontend/components/LearnerHome/Toolkit";

const Block = ({ contentDefinitionKey, relatedContents, ...props }) => {
    const item = relatedContents.find(
        (item) => item.contentDefinitionKey === contentDefinitionKey
    );
    if (!item) return "";
    const Block = fieldDefinitionKeys[item.contentDefinitionKey].component;
    return <Block {...item} {...props} />;
};

const LearnerWidget = ({ content: { relatedContents } }) => {
    useLayoutEffect(() => {
        require("../../../frontend/styles/Widgets.scss");
    }, []);

    const customBlocks = ["HeroBlock", "MenuBlock"];

    const content = relatedContents
        .filter((item) => !customBlocks.includes(item.contentDefinitionKey))
        .map((item, index) => (
            <Block
                contentDefinitionKey={item.contentDefinitionKey}
                relatedContents={relatedContents}
                key={index}
            />
        ));

    return (
        <div>
            <Block
                contentDefinitionKey={"HeroBlock"}
                relatedContents={relatedContents}
            />
            <Block
                withoutRouter
                contentDefinitionKey={"MenuBlock"}
                relatedContents={relatedContents}
            />
            <div className="learner-widget-content">{content}</div>

            <ProfileButton />
            <Toolkit />
        </div>
    );
};

export default LearnerWidget;



// WEBPACK FOOTER //
// ./src/widgets/components/Widgets/LearnerWidget.js